<div class="calendar-container">

    <div class="date-header">
        <div><span class="fa fa-chevron-left" (click)="prevMonth()"></span></div>
        <div>{{ fromDate | date : "MMMM yyyy" }}</div>
        <div><span class="fa fa-chevron-right" (click)="nextMonth()"></span></div>
    </div>
    <div class="loading" *ngIf="loading">
        <div class="loader"></div>
    </div>

    <div class="week-header">
        <div class="day">{{'bikeshop.quicklaunch.monday' | translate}}</div>
        <div class="day">{{'bikeshop.quicklaunch.tuesday' | translate}}</div>
        <div class="day">{{'bikeshop.quicklaunch.wednesday' | translate}}</div>
        <div class="day">{{'bikeshop.quicklaunch.thursday' | translate}}</div>
        <div class="day">{{'bikeshop.quicklaunch.friday' | translate}}</div>
        <div class="day">{{'bikeshop.quicklaunch.saturday' | translate}}</div>
        <div class="day">{{'bikeshop.quicklaunch.sunday' | translate}}</div>
    </div>
    <div *ngFor="let week of dates" class="week">
        <div *ngFor="let day of week" class="day" [duration]="500" (longPress)="daySelected(day)"
             (dblclick)="updateDateToggle(day)">
            <div *ngIf="day && day.dayOfMonth"
                 [ngClass]="{'working': day.working, 'not-working': !day.working, 'selected': day.working && day.dayOfMonth === selectedDay && !loading, 'updating': day.working && day.dayOfMonth === selectedDay && loading}">
                {{day.dayOfMonth}}
            </div>
            <div *ngIf="day && day.dayOfMonth && day.working && day.dayOfMonth === selectedDay && loading"
                 class="working rotate">

            </div>
            <!-- <div class="working-hours" *ngIf="day && day.working">
              <div class="base-bar"></div>
              <div class="hours-bar" [ngStyle]="{'width': day.workingHours / day.maxHours*100+'%'}"></div>
            </div> -->
            <!-- <div class="hours-dots" *ngIf="day && day.working">
              <div *ngFor="let hour of day.workingHoursArr">
                <span></span>
              </div>
            </div> -->
            <div class="hours" [ngClass]="{'hours-not-configured' : day.workingHours <= 0}" *ngIf="day && day.working">
                <div>
                    {{day.workingHours}}
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="showFunctionalityInfo" class="functionality-note margin-top-16"><span
            class="fa fa-circle"></span>{{ 'bikeshop.users.enable_disable_working_day' | translate }}</div>
    <div *ngIf="showFunctionalityInfo" class="functionality-note"><span
            class="fa fa-circle"></span>{{ 'bikeshop.users.select_working_day' | translate }}</div>
</div>
